import '../assets/scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
    const openMenuBtn = document.getElementById('open-mobile-menu');
    const closeMenuBtn = document.getElementById('close-mobile-menu');
    const mobileMenu = document.getElementById('mobile-menu-overlay');

    if (openMenuBtn && closeMenuBtn && mobileMenu) {
        openMenuBtn.addEventListener('click', () => {
            mobileMenu.classList.add('is-open');
        });

        closeMenuBtn.addEventListener('click', () => {
            mobileMenu.classList.remove('is-open');
        });
    }

    const header = document.querySelector('.header');
    const subNav = document.querySelector('.sub-nav');
    
    if (header) {
        window.addEventListener('scroll', () => {
            let isSubNavSticky = false;
            
            if (subNav) {
                const subNavRect = subNav.getBoundingClientRect();
                if (subNavRect.top <= 74) {
                    isSubNavSticky = true;
                    subNav.classList.add('is-sticky');
                } else {
                    subNav.classList.remove('is-sticky');
                }
            }

            if (window.scrollY > 0 && !isSubNavSticky) {
                header.classList.add('is-sticky');
            } else {
                header.classList.remove('is-sticky');
            }
        });
    }
});